/**
 * Google AdSense / pagead often returns 403 on localhost and other non-verified
 * origins. Skip network requests in those cases to avoid noisy devtools errors.
 */
export function isAdSenseBlockedHost(hostname: string): boolean {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '[::1]' ||
    hostname.endsWith('.localhost')
  );
}
